import React from 'react';
import { CardElement, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { Stripe, StripeCardElementChangeEvent, StripeElements, StripePaymentElementChangeEvent } from '@stripe/stripe-js';

interface IStripeCheckOutForm {
  onPaymentElementChange?: (event: StripePaymentElementChangeEvent) => void,
  isCard?:boolean
}

export interface StripeCheckOutFormRef {
  stripeInstance: Stripe | null;
  paymentElements: StripeElements | null;

}

const StripeCheckOutForm = React.forwardRef<StripeCheckOutFormRef, IStripeCheckOutForm>(({
  onPaymentElementChange,
}, ref) => {

  const stripe = useStripe();
  const elements = useElements();

  React.useImperativeHandle(ref, () => {
    return { stripeInstance: stripe, paymentElements: elements };
  }, [stripe, elements]);

  return <PaymentElement  onChange={onPaymentElementChange} />
  })

export default StripeCheckOutForm;